import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useHistory } from 'react-router-dom'
import { Link } from 'react-scroll'
import * as queryString from 'query-string'

import { Button } from '../../components/common'
import {
	Advertisement,
	Card,
	FilterCard,
	Footer,
	Main,
	Modal,
	Price,
} from '../../components/sale'

import {
	getCartoonifyImage,
	getConfirmationEmail,
	getEmail,
	getUserId,
	sendConfirmationEmail,
	setCartoonifyImage,
	setConfirmationEmail,
	setFlowTag,
	setFlowType,
	setIsLegalFlow,
	setIsRedirectingToLegal,
	getIsOnlyLegalFlow,
	setTotalPrice,
	showUnsubscribe,
	setProductId,
	setPurchaseType,
	setInitialPrice,
} from '../../redux/slices/userSlice'

import { ampEvent, ampSetUserProperty } from '../../utils/amplitude'
import { QueryHandler } from './handlers'
import {
	cartoonifyList,
	filtersList,
	predictionsList,
	zombifyList,
} from '../../utils/data'
import { offersList } from './offersList'

import './styles.scss'
import { getInitialPrice, getUpsellPrice } from '../../redux/slices/configSlice'
import { paramsToQuery } from '../../utils/historyDecorators'

const SaleScreen = () => {
	const { search, pathname } = useLocation()
	const history = useHistory()
	const dispatch = useDispatch()
	const params = queryString.parse(location.search)
	let flow_type = '1'
	let flow_tag = ''
	let isLegalFlow = true

	const isOnlyLegalFlow = useSelector(getIsOnlyLegalFlow)
	const user_id = useSelector(getUserId)
	const upsell_test = params?.upsell_test || useSelector(getUpsellPrice)
	const initial_price = params?.initial_price || useSelector(getInitialPrice)

	const [offers, setOffers] = useState(offersList)
	const selectedOffer = offers.find(offer => offer.isSelected)

	const handleSelectOffer = id =>
		setOffers(
			offers.map(offer => {
				if (offer.id === id) {
					offer.isSelected = true
					return offer
				}

				offer.isSelected = false
				return offer
			}),
		)

	if (pathname.includes('-3') || pathname.includes('-4')) {
		isLegalFlow = true
	} else {
		isLegalFlow = false
	}

	if (pathname === '/sale-1' || pathname === '/sale-2') {
		isLegalFlow = true
		if (pathname.includes('-2')) {
			flow_type = '2'
		}
	} else if (pathname.includes('sale11')) {
		flow_tag = '11'
		if (pathname.includes('-2')) {
			flow_type = '2'
		}
	} else if (pathname.includes('sale22')) {
		flow_tag = '22'
		if (pathname.includes('-1') || pathname.includes('-3')) {
			flow_type = '3'
		} else {
			flow_type = '4'
		}
	} else if (pathname.includes('sale33')) {
		flow_tag = '33'
		if (pathname.includes('-1') || pathname.includes('-3')) {
			flow_type = '5'
		} else {
			flow_type = '6'
		}
	} else if (pathname.includes('sale55')) {
		flow_tag = '55'
		if (pathname.includes('-1') || pathname.includes('-3')) {
			flow_type = '9'
		} else {
			flow_type = '10'
		}
	}

	const cartoonifyImage = useSelector(getCartoonifyImage)
	const email = useSelector(getEmail)
	const isConfirmEmailSended = useSelector(getConfirmationEmail)
	const [isActive, setIsActive] = useState(false)
	const [avaratify, cartoonify, babyfy, ageing] = filtersList
	const [cartoon, child, aging] = predictionsList
	const [cartoonifyNew, avatarifySmall, babyfySmall, ageingSmall] =
		cartoonifyList
	const [elfy, cartoonifyZ, orcStyle] = zombifyList
	const [isActiveModal, setIsActiveModal] = useState(false)

	useEffect(() => {
		dispatch(setIsLegalFlow({ isLegalFlow }))
		dispatch(setFlowType({ flow_type }))
		dispatch(setFlowTag({ flow_tag }))

		if (flow_type === '5') {
			if (cartoonifyImage) {
				fetch(cartoonifyImage)
					.then(res => {
						document.querySelector('#cartoonify-image').src = cartoonifyImage
					})
					.catch(res => {
						dispatch(setCartoonifyImage({ image: '' }))
					})
			}
		}

		if (flow_tag === '') {
			ampSetUserProperty(
				'flow',
				'default',
				user_id || params.user_id || window.id,
			)
		} else if (flow_tag === '11') {
			ampSetUserProperty(
				'flow',
				`${isOnlyLegalFlow ? 'default' : '11'}`,
				user_id || params.user_id || window.id,
			)
		}

		if (flow_type === '1' || flow_type === '5') {
			if (flow_type === '5') {
				ampSetUserProperty(
					'flow',
					`33${isLegalFlow || isOnlyLegalFlow ? '-3' : ''}`,
					user_id || params.user_id || window.id,
				)
			}
			ampSetUserProperty(
				'sale_type',
				'upload_photo',
				user_id || params.user_id || window.id,
			)
		} else if (flow_type === '2' || flow_type === '6') {
			if (flow_type === '6') {
				ampSetUserProperty(
					'flow',
					`33${isLegalFlow || isOnlyLegalFlow ? '-3' : ''}`,
					user_id || params.user_id || window.id,
				)
			}
			ampSetUserProperty(
				'sale_type',
				'quiz',
				user_id || params.user_id || window.id,
			)
		} else if (flow_type === '3') {
			ampSetUserProperty(
				'flow',
				`22${isLegalFlow || isOnlyLegalFlow ? '-3' : ''}`,
				user_id || params.user_id || window.id,
			)
			ampSetUserProperty(
				'sale_type',
				'marry',
				user_id || params.user_id || window.id,
			)
		} else if (flow_type === '4') {
			ampSetUserProperty(
				'flow',
				`22${isLegalFlow || isOnlyLegalFlow ? '-3' : ''}`,
				user_id || params.user_id || window.id,
			)
			ampSetUserProperty(
				'sale_type',
				'baby',
				user_id || params.user_id || window.id,
			)
		} else if (flow_type === '9' || flow_type === '10') {
			ampSetUserProperty(
				'flow',
				`55${isLegalFlow || isOnlyLegalFlow ? '-3' : ''}`,
				user_id || params.user_id || window.id,
			)
			if (flow_type === '10') {
				ampSetUserProperty(
					'sale_type',
					'quiz',
					user_id || params.user_id || window.id,
				)
			} else {
				ampSetUserProperty(
					'sale_type',
					'upload_photo',
					user_id || params.user_id || window.id,
				)
			}
		}
		setTimeout(() => {
			ampEvent('sales_screen_shown')
		}, 100)
		setTimeout(() => {
			setIsActive(true)
		}, 350)
		dispatch(showUnsubscribe({ isUnsubscribeShown: false }))
	}, [])

	useEffect(() => {
		dispatch(setTotalPrice({ totalPrice: selectedOffer?.price }))
		dispatch(
			setProductId({
				productId: isLegalFlow
					? selectedOffer?.productId
					: initial_price === 'flow_10'
					? process.env.REACT_APP_INITIAL_PRODUCT_ID
					: process.env.REACT_APP_AB_TEST_INITIAL_PRODUCT_ID,
			}),
		)
		dispatch(setPurchaseType({ purchaseType: selectedOffer?.type }))
		dispatch(
			setInitialPrice({
				initialPrice:
					isLegalFlow || initial_price === 'flow_99' ? '0.99' : '0.10',
			}),
		)
	}, [selectedOffer])

	useEffect(() => {
		if (isOnlyLegalFlow) {
			dispatch(setIsRedirectingToLegal({ isRedirectingToLegal: true }))

			if (flow_type === '1') {
				history.push({
					pathname: '/sale-1',
					search: paramsToQuery(params),
				})
			} else if (flow_type === '2') {
				history.push({
					pathname: '/sale-2',
					search: paramsToQuery(params),
				})
			} else if (flow_type === '3') {
				history.push({
					pathname: '/sale22-3',
					search: paramsToQuery(params),
				})
			} else if (flow_type === '4') {
				history.push({
					pathname: '/sale22-4',
					search: paramsToQuery(params),
				})
			} else if (flow_type === '5') {
				history.push({
					pathname: '/sale33-3',
					search: paramsToQuery(params),
				})
			} else if (flow_type === '6') {
				history.push({
					pathname: '/sale33-4',
					search: paramsToQuery(params),
				})
			} else if (flow_type === '9') {
				history.push({
					pathname: '/sale55-3',
					search: paramsToQuery(params),
				})
			} else if (flow_type === '10') {
				history.push({
					pathname: '/sale55-4',
					search: paramsToQuery(params),
				})
			}
		}
	}, [isOnlyLegalFlow])

	useEffect(() => {
		if (!isConfirmEmailSended) {
			const params = [
				{
					key: 'email',
					value: email,
				},
				{
					key: 'user_id',
					value: user_id,
				},
				{
					key: 'is_confirmation_email',
					value: true,
				},
				{
					key: 'external_id',
					value: user_id,
				},
			]

			if (initial_price && !isLegalFlow && !isOnlyLegalFlow) {
				params.push({
					key: 'initial_price',
					value: initial_price,
				})
			}

			if (upsell_test && !isLegalFlow && !isOnlyLegalFlow) {
				params.push({
					key: 'upsell_test',
					value: upsell_test,
				})
			}

			dispatch(
				sendConfirmationEmail({
					email,
					type_id: 11,
					project_id: process.env.REACT_APP_PROJECT_ID,
					button_url: {
						front_url: window.location.origin,
						pathname: location.pathname,
						queryParams: params,
					},

					report_url: '',
				}),
			).then(res => {
				if (+res.payload === 201) {
					dispatch(setConfirmationEmail())
				}
			})
		}
		QueryHandler(search, {
			setIsActiveModal: setIsActiveModal,
			dispatch,
		})
	}, [])

	const renderSaleScreen = () => {
		switch (flow_type) {
			case '1':
			case '2': {
				return (
					<>
						<FilterCard
							bgImgSrc="/images/sale/rainbow-bg.png"
							{...cartoonify}
						/>
						<FilterCard
							bgImgSrc="/images/sale/pink-sky-bg.png"
							{...avaratify}
						/>
						<div className="share-friends">
							<h3 className="share-friends__title">
								Create and share with your friends
							</h3>
							<img
								src="/images/sale/share-friends.png"
								alt="share-friends"
								className="share-friends__image"
							/>
						</div>
						<FilterCard bgImgSrc="/images/sale/colors2-bg.png" {...babyfy} />

						<FilterCard
							bgImgSrc="/images/sale/colors1-bg.png"
							{...ageing}
							isLast={true}
						/>
					</>
				)
			}
			case '3':
			case '4': {
				return (
					<>
						<FilterCard bgImgSrc="/images/sale/colors2-bg.png" {...child} />
						<FilterCard bgImgSrc="/images/sale/colors1-bg.png" {...aging} />
						<div className="share-friends">
							<h3 className="share-friends__title">
								Create and share with your friends
							</h3>
							<img
								src="/images/sale/share-friends.png"
								alt="share-friends"
								className="share-friends__image"
							/>
						</div>
						<FilterCard
							bgImgSrc="/images/sale/rainbow-bg.png"
							{...cartoon}
							isLast={true}
						/>
					</>
				)
			}
			case '5':
			case '6': {
				return (
					<>
						<FilterCard
							bgImgSrc="/images/sale/colors3-bg.png"
							{...cartoonifyNew}
						/>
						<Card
							image="edit-man"
							accent="+35M"
							title=" photos already edited"
							description="In love with animated movies? It’s time to become a part of your favorite!"
						/>
						<Card
							image="faces-in-circles"
							accent="Create"
							title=" unique profile pictures"
							description="Impress your followers and friends with Refine stunning features"
						/>
						<div className="share-friends">
							<h3 className="share-friends__title">
								Have fun and share with your friends
							</h3>
							<img
								src="/images/sale/share-friends.png"
								alt="share-friends"
								className="share-friends__image"
							/>
						</div>
						<div className="cartoonify-filter-cards">
							{!isLegalFlow && (
								<img
									src="/images/sale/apple-winner.png"
									alt="apple-winner"
									className="cartoonify-filter-cards__image"
								/>
							)}
							<h3 className="cartoonify-filter-cards__title">
								{`What else could be done with Refine ${
									isLegalFlow ? '(IOS, Android)' : ''
								}:`}
							</h3>
							<div className="cartoonify-filter-cards__list">
								<FilterCard {...avatarifySmall} />
								<FilterCard {...babyfySmall} />
								<FilterCard {...ageingSmall} />
							</div>
							<p className="cartoonify-filter-cards__description">
								Animate photos, swap faces, find out how will you age and how
								your future baby will look like{' '}
							</p>
							<div className="cartoonify-filter-cards__button-wrapper">
								<Link
									to="price"
									smooth={true}
									duration={1000}
									spy={true}
									exact="true"
									offset={-100}
								>
									<Button
										buttonText={`Try ${isLegalFlow ? 'now' : 'for free'}`}
									/>
								</Link>
							</div>
							<p className="cartoonify-filter-cards__more">
								and more features ...{' '}
							</p>
						</div>
					</>
				)
			}
			case '9':
			case '10': {
				return (
					<>
						<FilterCard
							bgImgSrc="/images/sale/dark-forest-bg.png"
							{...orcStyle}
						/>
						<FilterCard
							bgImgSrc="/images/sale/rainbow-bg.png"
							{...cartoonifyZ}
						/>
						<div className="share-friends">
							<h3 className="share-friends__title">
								Create and share with your friends
							</h3>
							<img
								src="/images/sale/share-friends-ork.png"
								alt="share-friends"
								className="share-friends__image"
							/>
						</div>
						<div className="margin-elfy"></div>
						<FilterCard bgImgSrc="/images/sale/colors4-bg.png" {...elfy} />
						<FilterCard
							bgImgSrc="/images/sale/pink-sky-bg.png"
							{...avaratify}
							isLast={true}
						/>
					</>
				)
			}
			default: {
				return <p>Component now found</p>
			}
		}
	}

	return (
		<div className={`sale-screen ${isActive ? 'sale-screen--active' : ''}`}>
			<Main
				isLegalFlow={isLegalFlow}
				flow_type={flow_type}
				flow_tag={flow_tag}
				cartoonifyImage={cartoonifyImage}
			/>
			{renderSaleScreen()}
			<Price
				isLegalFlow={isLegalFlow}
				setIsActiveModal={setIsActiveModal}
				flow_tag={flow_tag}
				selectedOffer={selectedOffer}
				offers={offers}
				handleSelectOffer={handleSelectOffer}
				initial_price={initial_price}
			/>
			<Advertisement flow_tag={flow_tag} />
			<Footer />
			<Modal
				setIsActiveModal={setIsActiveModal}
				isActiveModal={isActiveModal}
				total={isLegalFlow || initial_price === 'flow_99' ? '0.99' : '0.10'}
				annualPlan={isLegalFlow ? selectedOffer.price : 29.99}
				product_id={
					isLegalFlow
						? selectedOffer.productId
						: initial_price === 'flow_10'
						? process.env.REACT_APP_INITIAL_PRODUCT_ID
						: process.env.REACT_APP_AB_TEST_INITIAL_PRODUCT_ID
				}
			/>
		</div>
	)
}

export { SaleScreen }
